import { render, staticRenderFns } from "./menuTreea.vue?vue&type=template&id=7b761857&"
import script from "./menuTreea.vue?vue&type=script&lang=js&"
export * from "./menuTreea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports